export default interface BookingStatusBarInterface {
  type: BookingStatusBarTypes
  priority: BookingStatusBarPriority
  data: any
  customerId: number
  bookingId: number
}

export enum BookingStatusBarPriority {
  Regular = 'Regular',
  Success = 'Success',
  Warning = 'Warning',
  Important = 'Important',
}

export enum BookingStatusBarTypes {
  Cancelled = 'cancelled',
  Expired = 'expired',
  SecureBookingFullPayment = 'secure_booking_full_payment',
  SecureBookingDeposit = 'secure_booking_deposit',
  FullPaymentOverdue = 'full_payment_overdue',
  DepositOverdue = 'deposit_overdue',
  FullPaymentRequired = 'full_payment_required',
  DepositRequired = 'deposit_required',
  MissingPassengerInfo = 'missing_passenger_info',
  PredepartureInformationAvailable = 'predeparture_information_available',
  Confirmed = 'confirmed',
}
